import Vue from "vue";
import moment from "moment";
import {largeMonths} from '@/helpers/enums'
import Retirement from '@/classes/Retirement'

Vue.filter("capitalize", function(value)  {
  if(value != "" && value != undefined){
    value = value.toUpperCase();
  }
  return value
});

Vue.filter("percent", function(value)  {
  return `${value}%`;
});

Vue.filter("currency", function(value)  {
  const options2 = { style: 'currency', currency: 'MXN' };
  //const formatter = new Intl.NumberFormat('es-MX', options2);
  const formatter = new Intl.NumberFormat('en-US', options2);

  if (value != "" && value != undefined) {
    var resultado = Number(value.toString().replace(/[^0-9.-]+/g,"")).toString();
  
    if(!value.toString().includes(".")){
        resultado = value.toString() + ".00"
    }
    
    if(!resultado.includes(",")){
        resultado = resultado.replace(",","")//formatter.format(value)
    }
    resultado = formatter.format(resultado)
    
    resultado = resultado.replace('MX$','')
    
    if (resultado =="NaN" || resultado < 0) {
        resultado = ""
    }
    return '$' + resultado;
  }
  return '$0.00';
});

Vue.filter("camelize", function(value)  {
  if (value != "" && value != undefined) {
    let response = "";
    value = value.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, function(match) {
      return match.charAt(match.length-1).toUpperCase();
    });
    response = value.charAt(0).toUpperCase() + value.substring(1);
    return response.replace(/([A-Z])/g, ' $1').trim(); 
  }

  return "";
});

Vue.filter("moment", function(date)  {
  return moment(date).format("DD/MM/YYYY");
});

Vue.filter("typeRetirement", function(type)  {
  return Retirement.typeRetirement[type];
});

Vue.filter("dateToLetters", function(date)  {
  let dateSplit = date.split('-');
  return `${dateSplit[2]} de ${largeMonths[dateSplit[1]]} de ${dateSplit[0]}`
});
